import React, {useEffect, useState} from 'react';
import { Modal, Button } from 'react-bootstrap';
import connect from "react-redux/src/components/connect";

const mapStateToProps = (state, ownProps) => {
    return {
        anonymousMode: state.user.anonymousMode
    }
}

const InfoModal = props => {

  return (
    <Modal className={`modal fade bd-example-modal-lg ${props.anonymousMode ? "dark cw" : ""}`} show={props.isOpen} onHide={props.onClose}>
      <Modal.Header>
        <Modal.Title>
          {props.title}
        </Modal.Title>
        <button type="button" className="close" data-dismiss="modal" onClick={props.onClose} aria-hidden={props.isOpen}>×</button>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>{props.description}</p>
          {props.video && <iframe title="video" width="450" height="250" src={props.video} className="mobile-iframe" frameBorder="0" allow="autoplay; encrypted-media" />}
        </div>
      </Modal.Body>
    </Modal>
  )

};

export default connect(mapStateToProps, null)(InfoModal)
